<div class="modal-header">
        <h4 class="modal-title fw-bold">
            <!--<span *ngIf="attributeId" jhiTranslate="germplasm-attribute-modal.edit.header"></span> -->
            <span>{{ title | translate}}</span>
        </h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
                (click)="clear()">
        </button>
</div>
<div class="modal-body">
    <form name="form" #f="ngForm">
        <div class="mb-3 row required">
            <label for="dropdownvariable" class="col-sm-3 col-form-label fw-bold" jhiTranslate="germplasm-attribute-modal.variable">Variable</label>
            <div class="col-sm-9">
                <jhi-variable-select name="dropdownvariable" id="dropdownvariable"
                                     [allowClear]="true"
                                     (onVariableSelectedChange)="variable = $event"
                                     [variableTypeIds]="VARIABLE_TYPE_IDS"
                                     [germplasmUUID]="germplasmUUID">
                </jhi-variable-select>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="cancel"></span>
    </button>
    <button (click)="save()" [disabled]="!isFormValid(f)" class="btn btn-primary" data-test="addEntryDetailSubmit">
        <span *ngIf="isLoading" class="throbber throbber-btn"></span>
        <span class="fa fa-save"></span>&nbsp;<span jhiTranslate="save"></span>
    </button>
</div>
